<style lang="scss" scoped>
.page-intelligent {
    .c-datetime-range {
        max-width: 256px !important;
    }
    .map-container  {
        position: relative;
        border: 1px solid #eee;
        padding: 0px;
        margin: 0px;
        width: 100%;
        height: 700px;
    }
    .device-time {
        display: block;
        position: absolute;
        top: 5px;
        left: 5px;
        z-index: 10;
        background: rgba(255, 255, 255, .3);
        padding: 8px 12px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
        font-size: 12px;
    }
    /deep/ .device-searchs {
        display: block;
        position: absolute;
        top: 5px;
        left: 240px;
        z-index: 10;
        background: rgba(255, 255, 255, .3);
        padding: 1.5px;
        border-radius: 2px;
        box-shadow: 0 0 2px rgba(0,0,0,.5);
        font-size: 12px;
        .search-input {
            width: 120px;
            .el-input__inner {
                padding-left: 6px;
            }
        }
    }
    .total-count {
        display: block;
        position: absolute;
        top: 5px;
        right: 40px;
        z-index: 10;
        background-color: #ffffff;
        padding: 6px 12px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
    }
    .full-screen, .order-mousetools, .selected-list-btn {
        display: block;
        position: absolute;
        top: 5px;
        right: 5px;
        z-index: 10;
        background-color: #ffffff;
        padding: 2px;
        border-radius: 2px;
        box-shadow: 0 0 3px rgba(0,0,0,.5);
        cursor: pointer;
        .el-icon-full-screen {
            font-size: 26px;
        }
    }
    .full-screen:hover, .order-mousetools .btn:hover, .selected-list-btn:hover {
        background-color: #f0f0f0;
    }
    .order-mousetools {
        top: 42px;
        right: 40px;
        padding: 0;
        .btn {
            display: block;
            float: right;
            padding: 4px;
            i {
                font-size: 22px;
            }
        }
        .btn-open, .btn-open:hover {
            background: rgba(121, 184, 255, 1);
            i {
                color: #ffffff;
            }
        }
        .btn-actived {
            i {
                color: #79b8ff;
            }
        }
    }
    .cluster-list {
        padding: 10px 12px;
        border-bottom: 1px dashed #eee;
        .cluster-item {
            margin-top: 3px;
        }
    }
    .cluster-list:hover {
        background-color: #f5f5f5;
    }
    /deep/ .map-screen {
        margin: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
    }
    .selected-list-btn {
        display: block;
        right: 5px;
        top: 42px;
        font-size: 24px;
        padding: 0 3px;
    }
    /deep/ .selected-box {
        position: absolute;
        top: 76px;
        right: 4px;
        width: 510px;
        height: auto;
        z-index: 10;
        background: #fff;
        .el-table__body-wrapper {
            max-height: 400px;
            overflow-y: auto;
        }
        .point-btn {
            font-size: 14px;
            padding: 4px;
        }
    }
    /deep/ .row-highlight {
        td {
            background: #badaff;
        }
    }
}
</style>
<style>
.point-blue {
    display: inline-block; width: 10px; height: 10px; background: #4b9efc; border-radius: 10px;
}
.point-red {
    display: inline-block; width: 10px; height: 10px; background: #ff0000; border-radius: 10px;
}
</style>
<template>
    <div class="page-intelligent">
        <div class="toolbars mrgb10">
            <div class="buttons mrgb5">
                <div class="fl">
                    <el-tooltip effect="dark" content="更新当前实时分析数据，可获取到最新配置点位的车辆数据。" placement="top">
                        <el-button class="mrgb5" type="primary" size="medium" @click="_updateData()"><i class="fa fa-refresh"></i> 更新数据</el-button>
                    </el-tooltip>
                </div>
                <div class="fr">
                    <!-- <el-date-picker class="mrgr5 mrgb5" v-model="selectedDate" @change="initLoadData()"
                        type="date" size="medium" placeholder="请选择日期">
                    </el-date-picker>
                    <el-time-select class="c-el-input mrgr5 mrgb5" v-model="selectedStartTime" size="medium" 
                        @change="selectTime" placeholder="选择查询时间点" :editable="false"
                        :picker-options="{
                            start: '00:00',
                            step: '00:30',
                            end: '23:30'
                        }"
                    ></el-time-select>
                    <el-button type="primary" size="medium" @click="initLoadData()"><i class="fa fa-search"></i> 查询</el-button> -->
                    <el-tooltip effect="dark" placement="top">
                        <div slot="content">
                            注：每{{ spaceTime }}分钟更新一次实时车辆数据。<br />
                            车辆定位：仅代表【{{ deviceItem.time }}】之前的车辆实时定位。<br />
                            选中的车辆会加入到表格中，手动执行车辆分析后，地图上会按顺序生成路线图。<br />
                            时间、地址前面有定位图标代表该车辆有定位数据，否则就是未获取到车辆的最后定位。<br />
                        </div>
                        <el-tag class="mrgl5" type="warning" size="medium"><i class="el-icon-view f12"></i> 查看说明</el-tag>
                    </el-tooltip>
                </div>
                <div class="clearb"></div>
                <!-- <div>
                    <el-button-group>
                        <template v-for="(item, time) in pointTimes">
                            <el-button type="primary" size="medium" v-if="time % 2 === 0"
                                :plain="selectedStartTime !== item"
                                :key="item" @click="selectTime(item)">{{ time / 2 }}时</el-button>
                        </template>
                    </el-button-group>
                </div> -->
            </div>
        </div>
        <div class="map-container" :class="isScreen ? 'map-screen' : ''" id='mapDeviceScreen'>
            <span class="device-time">数据更新时间：{{ deviceItem.time }}</span>
            <span class="device-searchs" v-if="deviceItem.time">
                <el-input v-model="searchVehicleNumber" class="search-input" placeholder="车辆号搜索" size="mini" @change="searchVehicle()"></el-input>
                <el-button class="mrgl5" type="primary" size="mini" @click="searchVehicle()">查询</el-button>
            </span>
            <span class="total-count col_primary" title="当前查询出的总车辆数">总数量：{{ deviceItem.gps && deviceItem.gps.length || 0 }}</span>
            <span class="full-screen" :title="!isScreen ? '全屏' : '还原'" @click="isScreen = !isScreen">
                <i class="el-icon-full-screen"></i>
            </span>
            <span class="order-mousetools">
                <el-tooltip :content="isChooseVehicleOpen ? '结束选车' : '开始选车'" placement="top-end">
                    <span class="btn" :class="isChooseVehicleOpen ? 'btn-open' : ''"
                        @click="chooseSwitch()"><i :class="isChooseVehicleOpen ? 'el-icon-crop' : 'el-icon-crop'"></i></span>
                </el-tooltip>
                <template v-if="isChooseVehicleOpen">
                    <el-tooltip content="矩形选车" placement="top-end">
                        <span class="btn" :class="chooseType === chooseTypeArray[0] ? 'btn-actived' : ''"
                            @click="chooseVehicleType(chooseTypeArray[0])"><i class="el-icon-menu"></i></span>
                    </el-tooltip>
                    <el-tooltip content="圆形选车" placement="top-end">
                        <span class="btn" :class="chooseType === chooseTypeArray[1] ? 'btn-actived' : ''"
                            @click="chooseVehicleType(chooseTypeArray[1])"><i class="el-icon-bangzhu"></i></span>
                    </el-tooltip>
                    <el-tooltip :content="isChooseVehicleStatus ? '正在新增车辆' : '正在移除车辆'" placement="left-start">
                        <span class="btn"
                            @click="chooseVehicleStatus()"><i :class="isChooseVehicleStatus ? 'el-icon-plus' : 'el-icon-minus'"></i></span>
                    </el-tooltip>
                </template>
            </span>
            <div>
                <span class="selected-list-btn" @click="isShowSelectedFold = !isShowSelectedFold" :title="isShowSelectedFold ? '车辆选择列表收起' : '车辆选择列表展开'">
                    <i :class="!isShowSelectedFold ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
                </span>
                <div class="selected-box" v-if="isShowSelectedFold">
                    <el-table :data="selectedVehicles" border size="small" highlight-current-row
                        @row-click="rowClick">
                        <el-table-column label="" width="50">
                            <template slot="header">
                                <i @click="isShowSelectedFold = !isShowSelectedFold"
                                    :title="isShowSelectedFold ? '车辆选择列表收起' : '车辆选择列表展开'"
                                    style="font-size: 20px; cursor: pointer;"
                                    :class="!isShowSelectedFold ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
                            </template>
                            <template slot-scope="scope">
                                {{ ++scope.$index }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="carId" label="车辆号" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.carId }}
                                <el-tooltip :content="`由${scope.row.source}产生`" placement="left-start" v-if="scope.row.source">
                                    <el-tag type="success" size="mini" v-if="scope.row.source == '订单'">{{ scope.row.source }}</el-tag>
                                    <el-tag type="warning" size="mini" v-else>{{ scope.row.source }}</el-tag>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" label="[最后一次时间] 定位地址" width="200">
                            <template slot-scope="scope">
                                <i class="col_primary el-icon-location f16" v-if="scope.row.latitude && scope.row.longitude"></i>
                                <span class="col_info" v-if="scope.row.time">[{{ scope.row.time }}]</span>
                                {{ scope.row.address }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="stateDesc" label="状态" width="60">
                            <template slot-scope="scope">
                                <el-tooltip content="数据获取成功" placement="top" v-if="scope.row.state === 1">
                                    <el-tag type="success" size="mini">
                                        {{ scope.row.stateDesc }}
                                    </el-tag>
                                </el-tooltip>
                                <el-tooltip content="数据获取失败" placement="top" v-else-if="scope.row.state === -1">
                                    <el-tag type="danger" size="mini">
                                        {{ scope.row.stateDesc }}
                                    </el-tag>
                                </el-tooltip>
                                <el-tag type="warning" size="mini" v-else-if="scope.row.state === 0">
                                    {{ scope.row.stateDesc }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button class="point-btn" type="primary" size="mini" plain @click.stop="refreshData(scope.row)"><i class="el-icon-refresh"></i></el-button>
                                <el-button class="point-btn" type="danger" size="mini" plain @click.stop="deleteChoose(scope.row, scope.$index)"><i class="el-icon-delete"></i></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="tc">
                        <el-button class="mrgt5 mrgb5" type="danger" size="mini" @click="queryRouteLine()">分析车辆({{ selectedVehicles.length }})</el-button>
                        <el-button class="mrgt5 mrgb5" type="warning" size="mini" @click="refreshData()" v-if="fialdVehicles.length > 0">重试失败车辆({{ fialdVehicles.length }})</el-button>
                        <el-button class="mrgt5 mrgb5" size="mini" @click="clearAllChoose()">清空</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as funReport from "@/api/report"
import moment from 'moment'

let dataVars = {
    map: null,
    polygonMap: null, // 设置服务区的范围
    parkingMarker: [],
    markers: null,
    infoWindow: null,
    mouseTool: null, // 鼠标绘制工具
    polygonObj: null,
    ruleTool: null,
    routeLines: [] // 线路
}
export default {
    name: "pageIntelligent",
    data() {
        return {
            pageHeader: {
                desc: "查询当前车辆的最后订单或者挪车的点位及线路。"
            },
            listQuery: {
                area: "",
                beginDate: "",
                endDate: ""
            },
            coverMarker: null,
            coverPaths: [], // 服务区多边形点位
            isShowParking: true,
            parkings: [],
            deviceItem: [],
            isScreen: false,
            selectedDate: moment(),
            selectedTime: [],
            spaceTime: 30, // 选择间隔时间30分钟
            pointTimes: [],
            selectedStartTime: "",
            /**********车辆选点功能**********/
            isChooseVehicleOpen: false, // 选车开关，false可以移动地图
            chooseTypeArray: [1, 2],
            chooseType: null,
            isChooseVehicleStatus: true,
            polygonColor: "#1791fc",
            isShowSelectedFold: true,
            selectedVehicles: [],
            fialdVehicles: [],
            vehiclePointIcons: ['<img width="10" height="10" src="/static/images/map/mass0.png" />', '<img width="10" height="10" src="/static/images/map/point.png" />'],
            searchVehicleNumber: "",  // 快速搜索车辆号
            lineColors: ["#f78989", "#67c23a"],
        }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.initLoadData()
            })
        }
    },
    async mounted() {
        await this.open()
    },
    unmounted() {
        dataVars.map?.destroy()
        document.removeEventListener("keydown")
        document.removeEventListener("keyup")
    },
    methods: {
        async open(row) {
            this.setSysPageHeader(this.pageHeader)
            this.setPointTimes()
            await this.initMap()
            await this.initLoadData()
            this.loadKeyDown()
            this.loadKeyUp()
        },
        setPointTimes() {
            for (let i = 0; i < 24; i++) {
                let hour = i < 10 ? ("0" + i ) : i
                let time = moment().format(`YYYY-MM-DD ${hour}:00:00`)
                let sTime = moment(time).format("HH:mm")
                let eTime = moment(time).add(this.spaceTime, "m").format("HH:mm")
                this.pointTimes.push(sTime, eTime)
            }
        },
        setSelectedTime() {
            let psDate = ""
            let psTime = ""
            let peDate = ""
            let peTime = ""
            // 日期段
            if (this.selectedDate && moment(this.selectedDate).isValid()) {
                // 时间段
                if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
                    psTime = moment(this.selectedTime[0]).format("HH:mm:ss")
                } else {
                    psTime = moment(this.selectedDate).format("00:00:00")
                }
                if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
                    peTime = moment(this.selectedTime[1]).format("HH:mm:ss")
                } else {
                    peTime = moment(this.selectedDate).format("23:59:59")
                }
                psDate = moment(this.selectedDate).format(`YYYY-MM-DD ${psTime}`)
                peDate = moment(this.selectedDate).format(`YYYY-MM-DD ${peTime}`)
            }
            this.listQuery.beginDate = psDate
            this.listQuery.endDate = peDate
            this.selectedTime = [`${this.listQuery.beginDate}`, `${this.listQuery.endDate}`]
        },
        async initMap() {
            await window.$common.loadGaoDeMap({ plugins: ["AMap.MouseTool"] }, (Amap) => {
                // 生成地图
                this.initCreateMap()
            })
        },
        // 时间段选择
        selectTime(time) {
            this.selectedTime = []
            this.selectedStartTime = time
            let psTime = ""
            let peTime = ""
            if (this.selectedDate && moment(this.selectedDate).isValid()) {
                psTime = moment(this.selectedDate).format("YYYY-MM-DD " + time + ":00")
                peTime = moment(psTime).add(this.spaceTime, "m").format("YYYY-MM-DD HH:mm:00")
                this.selectedTime = [psTime, peTime]
                this.initLoadData()
            }
        },
        _updateData() {
            if (this.deviceItem && this.deviceItem.id) {
                funReport.UpdateDeviceScreen({ id: this.deviceItem.id }).then(res => {
                    this.initLoadData()
                })
            } else {
                this.warningMsg("当前没有车辆数据!")
                return false
            }
        },
        async getDataList() {
            this.setSelectedTime()
            await funReport.GetDeviceScreenLatest(this.listQuery).then(response => {
                this.deviceItem = response || {}
                this.deviceItem.time = moment(this.deviceItem.time).format("YYYY-MM-DD HH:mm:ss")
            })
        },
        // 获取车辆的最后定位信息
        async getLastLocation(ids) {
            if (!ids) {
                ids = []
            }
            // 设置成加载中样式
            this.setLoadingStyle(ids)
            let res = null
            await funReport.GetVehicleLastLocation({ ids }).then(response => {
                res = response.map(x => {
                    x.state = 1
                    return x
                })
            }).catch(err => {
                res = ids.map(x => {
                    return {
                        vehicleId: x,
                        state: -1
                    }
                })
            })
            console.log(res)
            return res
        },
        // 生成地图
        initCreateMap() {
            let zoom = 16
            dataVars.map = new AMap.Map("mapDeviceScreen", {  //设置地图容器id
                viewMode: "2D",    //是否为3D地图模式
                zoom: zoom,           //初始化地图级别
                center: [104.065861,30.657401], //初始化地图中心点位置
                // scrollWheel: false
            })
            dataVars.map.addControl(new AMap.ToolBar())
            dataVars.map.addControl(new AMap.Scale())
            // 创建鼠标绘制
            this.setMouseTools()
            // 右键
            this.setContextMenu()
        },
        setContextMenu() {
            // 创建右键
            let contextMenu = new AMap.ContextMenu()
            contextMenu.addItem("<i class='el-icon-plus'></i> 新增车辆", (e) => {
                this.chooseSwitch(true)
                this.chooseVehicleStatus(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-minus'></i> 移除车辆", (e) => {
                this.chooseSwitch(true)
                this.chooseVehicleStatus(false)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-menu'></i> 矩形框选", (e) => {
                this.chooseType = this.chooseTypeArray[0]
                this.chooseSwitch(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-bangzhu'></i> 圆形框选", (e) => {
                this.chooseType = this.chooseTypeArray[1]
                this.chooseSwitch(true)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-lock'></i> 结束框选", (e) => {
                this.chooseSwitch(false)
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-c-scale-to-original'></i> 开始/清空测距", (e) => {
                if (!dataVars.ruleTool) {
                    dataVars.ruleTool = new AMap.MouseTool(dataVars.map)
                    dataVars.ruleTool.rule()
                } else {
                    dataVars.ruleTool.close(true)
                    dataVars.ruleTool = null
                }
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-full-screen'></i> 全屏/取消全屏", (e) => {
                this.isScreen = !this.isScreen
                contextMenu.close()
            })
            contextMenu.addItem("<i class='el-icon-switch-button'></i> 关闭右键菜单", (e) => {
                contextMenu.close()
            })
            dataVars.map.on('rightclick', (e) => {
                contextMenu.open(dataVars.map, e.lnglat)
            })
        },
        async initLoadData() {
            this.clearAllMarkers()
            this.listQuery.area = this.$store.getters.serviceArea || ""
            window.$common.fullLoading()
            this.getCurrentAreaData()
            this.setPolygonContains()
            await this.getPackings()
            await this.getDataList()
            // 设置车辆点位marker
            this.setAllMarkers()
            // 创建窗体
            this.createinfoWindow()
            // 清空所有路线图数据
            this.clearAllChooseData()
            window.$common.closeFullLoading()
        },
        // 获取服务区的定位path信息
        getCurrentAreaData() {
            let areaName = this.$store.getters.serviceArea || ""
            let areaList = this.$store.getters.serviceAreas || []
            let areaItem = areaList.find(x => { return x.name === areaName })
            if (areaItem) {
                this.coverMarker = areaItem || {}
                this.coverPaths = areaItem.pointList || []
            }
        },
        // 设置多边形数据--服务区的范围
        setPolygonContains() {
            dataVars.polygonMap && dataVars.map.remove(dataVars.polygonMap)
            let path = this.coverPaths
            if (path.length <= 0) {
                return false
            }
            dataVars.polygonMap = new AMap.Polygon({
                bubble: true,
                path: path,
                strokeColor: "#409EFF", 
                strokeWeight: 3,
                strokeOpacity: 0.5,
                fillOpacity: 0.05,
                strokeStyle: 'dashed',
                strokeDasharray: [5, 5]
            })
            dataVars.map.add(dataVars.polygonMap)
            // 服务区有中心点则移动到服务区中心
            if (this.coverMarker && this.coverMarker.centerLng && this.coverMarker.centerLat) {
                let curLnglat = [this.coverMarker.centerLng, this.coverMarker.centerLat]
                this.moveToCenter({ lnglat: curLnglat })
            }
        },
        // 站点数据
        async getPackings() {
            this.parkings = []
            let area = this.$store.getters.serviceArea || ""
            await funReport.GetParkingLocations({ area }).then(response => {
                this.parkings = response
            })
            this.setPackingData()
        },
        // 设置站点信息
        setPackingData() {
            this.clearParking()
            if (this.isShowParking) {
                let markers = []
                let datas = JSON.parse(JSON.stringify(this.parkings))
                for (let i in datas) {
                    let item = datas[i]
                    let marker = new AMap.Polygon({
                        zIndex: 100,
                        bubble: true,
                        path: item.pointList,
                        strokeWeight: 1,
                        fillColor: "#f56c6c", // "#f56c6c",
                        fillOpacity: 0.2,
                        strokeColor: "#f56c6c", // "#f56c6c"
                        extData: item
                    })
                    marker.on("click", (ev) => {
                        let packItem = ev.target.getExtData()
                        funReport.GetParkingById({ id: packItem.id }).then(res => {
                            let content = `<div>
                                                <div class="txtClose" style="position: absolute; z-index: 100; top: -6px; right: -6px;"><i class="el-icon-error f16 col6"></i></div>
                                                <div class="f13" style="padding: 5px 8px 5px 5px;">
                                                    <div>站点名称：${res.name} <i class="el-icon-document-copy col_primary"></i></div>
                                                </div>
                                            </div>`
                            this.mxCommonMapTextInfo(dataVars.map, {
                                text: content,
                                position: [res.centerLng, res.centerLat]
                            }, () => {
                                try {
                                    window.navigator.clipboard.writeText(res.name).then(() => {
                                        this.successMsg("复制成功!")
                                    })
                                } catch(ex) {
                                    this.alert(res.name, "手动复制站点", {
                                        customClass: "wordbreakba"
                                    })
                                }
                            })
                        })
                    })
                    dataVars.parkingMarker.push(marker)
                    dataVars.map.add(marker)
                }
            }
        },
        // 设置车辆点marker
        setAllMarkers(datas) {
            let items = datas || this.deviceItem.gps || []
            let markers = []
            for (let i in items) {
                let item = items[i]
                let marker = new AMap.Marker({
                    position: [item.lng, item.lat],
                    anchor: "center",
                    content: this.vehiclePointIcons[1],
                    offset: new AMap.Pixel(0, 0),
                    extData: item
                })
                marker.on("click", (ev) => {
                    let target = ev.target.getExtData()
                    let pos = ev.target.getPosition()
                    dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0;">车辆号：${target.carId}</span>`)
                    dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                })
                markers.push(marker)
            }
            if (items.length > 0) {
                dataVars.map.add(markers)
                dataVars.markers = markers
            }
        },
        // 创建信息窗体
        createinfoWindow() {
            dataVars.infoWindow = new AMap.InfoWindow({
                content: "",
                offset: [0, -4],
                autoMove: true
            })
        },
        clearAllMarkers() {
            this.clearParking()
            this.clearMarkers()
            this.clearRouteLine()
        },
        clearParking() {
            for (let i in dataVars.parkingMarker) {
                dataVars.map.remove(dataVars.parkingMarker[i])
            }
            dataVars.parkingMarker = []
        },
        clearMarkers() {
            dataVars.markers && dataVars.map.remove(dataVars.markers)
            dataVars.markers = null
        },
        // 清空路线
        clearRouteLine() {
            for (let i in dataVars.routeLines) {
                dataVars.map.remove(dataVars.routeLines[i])
            }
            dataVars.routeLines = []
        },
        moveToCenter(item) {
            dataVars.map.setCenter(item.lnglat, false, 50)
        },
        /************鼠标绘制选点************/
        // 创建鼠标绘制
        setMouseTools() {
            dataVars.mouseTool = new AMap.MouseTool(dataVars.map)
            dataVars.mouseTool.on("draw", (event) => {
                dataVars.polygonObj = event.obj
                // event.obj 为绘制出来的覆盖物对象
                for (let i in dataVars.markers) {
                    let item = dataVars.markers[i]
                    let target = item.getExtData()
                    target.address =  target.address || ""
                    target.time = target.time || ""
                    target.latitude = target.latitude || null
                    target.longitude = target.longitude || null
                    target.source = target.source || ""
                    target.state = target.state || null
                    let pos = item.getPosition()
                    if (dataVars.polygonObj.contains(pos)) {
                        if (this.isChooseVehicleStatus) {
                            item.setContent(this.vehiclePointIcons[0])
                            let temp = this.selectedVehicles.find(x => x.carId === target.carId)
                            if (!temp) {
                                this.selectedVehicles.push(target)
                            }
                        } else {
                            item.setContent(this.vehiclePointIcons[1])
                            let tempIndex = this.selectedVehicles.findIndex(x => x.carId === target.carId)
                            if (tempIndex !== -1) {
                                this.selectedVehicles.splice(tempIndex, 1)
                            }
                        }
                    }
                }
                dataVars.map.remove(dataVars.polygonObj)
            })
        },
        // 删除车辆
        deleteChoose(row, index) {
            // 车辆点位恢复默认颜色
            for (let i in dataVars.markers) {
                let item = dataVars.markers[i]
                let target = item.getExtData()
                if (row.carId === target.carId) {
                    item.setContent(this.vehiclePointIcons[1])
                    break
                }
            }
            // 删除路线
            for (let i in dataVars.routeLines) {
                let item = dataVars.routeLines[i]
                let target = item.getExtData()
                if (row.carId === target.vehicleId) {
                    dataVars.map.remove(dataVars.routeLines[i])
                    dataVars.routeLines.splice(i, 1)
                    break
                }
            }
            // 删除表中车辆
            this.selectedVehicles.splice(index, 1)
        },
        // 选中行，车辆路线变颜色
        rowClick(row, column, event) {
            for (let i in dataVars.routeLines) {
                let item = dataVars.routeLines[i]
                let target = item.getExtData()
                let option = item.getOptions()
                if (row.carId === target.vehicleId) {
                    this.setStrokeOptions(item, option, { color: this.lineColors[0], weight: 3 })
                } else {
                    this.setStrokeOptions(item, option, { color: this.lineColors[1], weight: 1.5 })
                }
            }
        },
        // 分析车辆
        async queryRouteLine() {
            if (this.selectedVehicles.length <= 0) {
                this.warningMsg("没有选择车辆!")
                return false
            }
            const carIds = this.selectedVehicles.map(x => x.carId)
            const chunkSize = 5
            const chunks = Array.from({ length: Math.ceil(carIds.length / chunkSize) }, (_, i) => 
                carIds.slice(i * chunkSize, (i + 1) * chunkSize)
            )
            // 画线先清空原来的路线
            this.clearRouteLine()
            // 串行执行每个chunk的查询
            // window.$common.fullLoading()
            for (const chunk of chunks) {
                const res = await this.getLastLocation(chunk)
                this.updateVehicles(res)
                this.setVehicleLine(res)
            }
            // 设置失败的车辆
            this.fialdVehicles = this.selectedVehicles.filter(x => x.state === -1)
            // window.$common.closeFullLoading()
            this.successMsg("车辆路线分析完成")
        },
        async refreshData(rows) {
            if (!rows) {
                rows = this.selectedVehicles.filter(x => x.state === -1)
            } else {
                rows = [rows]
            }
            if (rows.length <= 0) {
                this.warningMsg("暂无失败车辆数据!")
                return false
            }
            // 先删除原来的路线
            for (let i in dataVars.routeLines) {
                let item = dataVars.routeLines[i]
                let target = item.getExtData()
                if (rows.find(x => x.carId === target.vehicleId)) {
                    dataVars.map.remove(dataVars.routeLines[i])
                    dataVars.routeLines.splice(i, 1)
                }
            }
            const carIds = rows.map(x => x.carId)
            // window.$common.fullLoading()
            const res = await this.getLastLocation(carIds)
            this.updateVehicles(res)
            this.setVehicleLine(res)
            // 设置失败的车辆
            this.fialdVehicles = this.selectedVehicles.filter(x => x.state === -1)
            // window.$common.closeFullLoading()
            this.successMsg("数据已更新")
        },
        // 设置成加载中样式，单条数据初始化
        setLoadingStyle(carIds) {
            for (let i in carIds) {
                let item = carIds[i]
                let index = this.selectedVehicles.findIndex(x => x.carId === item)
                if (index !== -1) {
                    this.selectedVehicles[index].address = ""
                    this.selectedVehicles[index].time = ""
                    this.selectedVehicles[index].latitude = null
                    this.selectedVehicles[index].longitude = null
                    this.selectedVehicles[index].source = ""
                    this.selectedVehicles[index].state = 0
                    this.selectedVehicles[index].stateDesc = "加载中"
                    this.$set(this.selectedVehicles, index, this.selectedVehicles[index])
                }
            }
        },
        // 更新地址
        updateVehicles(res) {
            for (let i in res) {
                let item = res[i]
                let index = this.selectedVehicles.findIndex(x => x.carId === item.vehicleId)
                if (index !== -1) {
                    this.selectedVehicles[index].address = item.address
                    this.selectedVehicles[index].time = this.getFormatDate(item.time)
                    this.selectedVehicles[index].latitude = item.latitude
                    this.selectedVehicles[index].longitude = item.longitude
                    this.selectedVehicles[index].source = item.source
                    this.selectedVehicles[index].state = item.state || 0
                    this.selectedVehicles[index].stateDesc = item.state === 1 ? "成功" : item.state === -1 ? "失败" : "加载中"
                    this.$set(this.selectedVehicles, index, this.selectedVehicles[index])
                }
            }
        },
        // 设置路线图
        setVehicleLine(startItems) {
            for (let i in startItems) {
                let item = startItems[i]
                let endItem = this.selectedVehicles.find(x => x.carId == item.vehicleId)
                item.lineStartLng = item.longitude
                item.lineStartLat = item.latitude
                item.lineEndLng = endItem && endItem.lng
                item.lineEndLat = endItem && endItem.lat
                // 挪车没有开始和结束位置，就排除
                if (!item.lineStartLng || !item.lineStartLat || !item.lineEndLng || !item.lineEndLat) {
                    continue
                }
                let arr = []
                let baseLng = 0
                let baseLat = 0
                // 结束经度 > 开始经度，结束纬度 > 开始纬度
                if (item.lineEndLng >= item.lineStartLng && item.lineEndLat > item.lineStartLat) {
                    baseLng = -0.002
                    baseLat = 0.003
                } else if (item.lineEndLng >= item.lineStartLng && item.lineEndLat < item.lineStartLat) {
                    baseLng = 0.002
                    baseLat = 0.003
                } else if (item.lineEndLng <= item.lineStartLng && item.lineEndLat < item.lineStartLat) {
                    baseLng = 0.002
                    baseLat = -0.003
                } else if (item.lineEndLng <= item.lineStartLng && item.lineEndLat > item.lineStartLat) {
                    baseLng = -0.002
                    baseLat = -0.003
                }
                let ctLng = (item.lineStartLng + item.lineEndLng) / 2 + baseLng * 2
                let ctLat = (item.lineStartLat + item.lineEndLat) / 2 + baseLat * 2
                arr = [
                    [item.lineStartLng, item.lineStartLat],
                    [ctLng, ctLat, item.lineEndLng, item.lineEndLat]
                ]
                let parkLine = new AMap.BezierCurve({
                    bubble: true,
                    path: arr,            // 设置线覆盖物路径
                    strokeColor: this.lineColors[1], // 线颜色
                    strokeOpacity: 0.8,         // 线透明度
                    strokeWeight: 1.5,          // 线宽
                    strokeStyle: 'solid',     // 线样式
                    showDir: true,
                    extData: item
                })
                dataVars.routeLines.push(parkLine)
                dataVars.map.add(parkLine)
            }
        },
        // 动态设置线路的颜色
        setStrokeOptions(obj, options, stroke) {
            options.strokeColor = stroke && stroke.color
            options.strokeWeight = stroke && stroke.weight || 1.5
            obj.setOptions(options)
            obj.show()
        },
        // 清空车辆
        clearAllChoose() {
            this.confirm("确定要清空选择的车辆吗?").then(() => {
                this.clearAllChooseData()
            })
        },
        clearAllChooseData() {
            for (let i in dataVars.markers) {
                let item = dataVars.markers[i]
                let target = item.getExtData()
                item.setContent(this.vehiclePointIcons[1])
            }
            this.clearRouteLine()
            this.selectedVehicles = []
            this.fialdVehicles = []
        },
        chooseSwitch(isOpen) {
            if (isOpen !== undefined) {
                this.isChooseVehicleOpen = isOpen
            } else {
                this.isChooseVehicleOpen = !this.isChooseVehicleOpen
            }
            if (!this.isChooseVehicleOpen) {
                dataVars.mouseTool && dataVars.mouseTool.close(true)
            } else {
                this.chooseVehicleType(this.chooseType)
            }
        },
        chooseVehicleType(type) {
            // 先移除之前的选框对象
            dataVars.polygonObj && dataVars.map.remove(dataVars.polygonObj)
            this.polygonColor = this.isChooseVehicleStatus ? "#1791fc" : "#f56c6c"
            this.chooseType = type || this.chooseTypeArray[0]
            let options = {
                strokeColor: this.polygonColor, //轮廓线颜色
                strokeOpacity: 0.3, //轮廓线透明度
                strokeWeight: 2, //轮廓线宽度
                fillColor: this.polygonColor, //多边形填充颜色
                fillOpacity: 0.6, //多边形填充透明度
                strokeStyle: "solid", //线样式还支持 'dashed'
            }
            if (this.chooseType === this.chooseTypeArray[0]) {
                dataVars.mouseTool.rectangle(options)
            } else if (this.chooseType === this.chooseTypeArray[1]) {
                dataVars.mouseTool.circle(options)
            }
        },
        chooseVehicleStatus(isAdd) {
            if (isAdd !== undefined) {
                this.isChooseVehicleStatus = isAdd
            } else {
                this.isChooseVehicleStatus = !this.isChooseVehicleStatus
            }
            this.chooseVehicleType(this.chooseType)
        },
        loadKeyDown() {
            document.addEventListener("keydown", (obj) => {
                let key = obj.key
                if (key === "Control") {
                    this.chooseSwitch(true)
                    this.chooseVehicleStatus(true)
                } else if (key === "Alt") {
                    this.chooseSwitch(true)
                    this.chooseVehicleStatus(false)
                }
            })
        },
        loadKeyUp() {
            document.addEventListener("keyup", (obj) => {
                let key = obj.key
                if (key === "Control") {
                    this.chooseSwitch(false)
                } else if (key === "Alt") {
                    this.chooseSwitch(false)
                }
            })
        },
        // 搜索车辆
        searchVehicle() {
            let temp = dataVars.markers.find(ev => {
                let target = ev.getExtData()
                return target.carId === this.searchVehicleNumber
            })
            if (temp) {
                let target = temp.getExtData()
                let pos = temp.getPosition()
                dataVars.infoWindow.setContent(`<span style="padding: 0 10px 0 0;">车辆号：${target.carId}</span>`)
                dataVars.infoWindow.open(dataVars.map, [pos.lng, pos.lat])
                dataVars.map.setCenter([pos.lng, pos.lat], null, 100)
                this.searchVehicleNumber = ""
            }
        },
    }
}
</script>